<template>
  <nav class="confetti-nav">
    <div class="confetti-nav-scroll-container">
      <slot />
      <div v-if="logoPath" class="company-logo">
        <img :src="logoPath" alt="Kloeckner.i logo" />
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ConfettiNav",
  props: {
    logoPath: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/variables/layout";
@import "confetti/scss/variables/z-index";
@import "confetti/scss/layout/confetti-nav";
</style>
